import { useInstrument } from "@/App/Equities/shared/services/instruments"
import type { Instrument } from "@/generated/TradingGateway"

interface InstrumentFieldProps<
  Field extends keyof Omit<Instrument, "tradable">,
> {
  symbol: string
  field: Field
  formatter?: (input: Instrument[Field]) => string
}

export const InstrumentInfoDataPoint = ({
  symbol,
  field,
  formatter,
}: InstrumentFieldProps<keyof Omit<Instrument, "tradable">>) => {
  let attribute = useInstrument(symbol)?.[field]
  if (formatter && attribute) {
    attribute = formatter(attribute)
  }
  return attribute
}
